import { render, staticRenderFns } from "./SelectImgModal.vue?vue&type=template&id=66edacea&scoped=true"
import script from "./SelectImgModal.vue?vue&type=script&lang=js"
export * from "./SelectImgModal.vue?vue&type=script&lang=js"
import style0 from "./SelectImgModal.vue?vue&type=style&index=0&id=66edacea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66edacea",
  null
  
)

export default component.exports